import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../ui/UIElements/Modal";
import AgentTemplatesSection from "./AgentTemplatesSection";

/**
 * AgentTemplatesModal — standalone modal that hosts the WhatsApp message
 * templates list for a single agent. Opened from the "View Templates" button
 * in AgentDetailModal. Only meaningful for agents where provider === "whatsapp".
 */
const AgentTemplatesModal = ({ isOpen, onClose, agent }) => {
  const { t } = useTranslation("aiAgents");

  if (!agent) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("templates.title")}
      subtitle={t("templates.description")}
      maxWidth="max-w-4xl"
    >
      <AgentTemplatesSection agent={agent} showHeader={false} />
    </Modal>
  );
};

export default AgentTemplatesModal;
